import React from "react";
import { useSelector } from "react-redux";

function ReviewFrequency() {
  const {reportingFrequency, monitoringFrequency} = useSelector(
    (state) => ({
      fields: state.deviceProfile.ui.form.fields.step4,
      reportingFrequency: `${state?.deviceProfile?.ui?.form?.fields?.step4?.reportingFrequency?.value?.value||""} ${state?.deviceProfile?.ui?.form?.fields?.step4?.reportingFrequency?.unit?.value||""}`,
      monitoringFrequency: `${state?.deviceProfile?.ui?.form?.fields?.step4?.monitorFrequency?.value?.value||""} ${state?.deviceProfile?.ui?.form?.fields?.step4?.monitorFrequency?.unit?.value||""}`
    })
  );

  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171",
        }}
      >
        Frequency
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Reporting Frequency
          </span>
          <div className="txt-label">{reportingFrequency?.trim() === "" ? "None" : reportingFrequency}</div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Monitoring Frequency
          </span>
          <div className="txt-label">{monitoringFrequency?.trim() === "" ? "None" : monitoringFrequency}</div>
        </div>
      </div>
    </>
  );
}

export default ReviewFrequency;
